var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.24,
    cx: 20,
    cy: 20,
    r: 19.65,
    stroke: "#1F2647",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.627 15.1409H17.7193V13.4844C17.7193 12.9992 18.0481 12.6966 18.5586 12.6966H21.4345C21.9413 12.6966 22.27 12.9992 22.27 13.4844V15.1409H23.3692V13.4157C23.3692 12.3308 22.6615 11.666 21.497 11.666H18.4892C17.3347 11.666 16.627 12.3308 16.627 13.4157V15.1409ZM13.0149 15.687H26.9882C27.2762 15.687 27.5 15.4533 27.5 15.1683C27.5 14.8772 27.2662 14.6496 26.9882 14.6496H13.0149C12.7437 14.6496 12.5 14.8803 12.5 15.1683C12.5 15.4564 12.7437 15.687 13.0149 15.687ZM16.452 28.9406H23.5579C24.6157 28.9406 25.3543 28.235 25.4078 27.1765L25.9685 15.5501H24.86L24.3161 27.0642C24.2932 27.5491 23.936 27.9032 23.4518 27.9032H16.5382C16.0709 27.9032 15.7068 27.5422 15.6839 27.0642L15.1163 15.5532H14.0346L14.6053 27.1833C14.6588 28.2418 15.3805 28.9406 16.452 28.9406ZM17.681 26.4778C17.9515 26.4778 18.1211 26.3089 18.1142 26.0652L17.8637 17.5775C17.8569 17.3269 17.6781 17.1711 17.4305 17.1711C17.17 17.1711 16.9905 17.3338 16.9973 17.5837L17.2478 26.0683C17.2547 26.3189 17.4274 26.4778 17.681 26.4778ZM20.0016 26.4778C20.269 26.4778 20.4485 26.312 20.4485 26.0652V17.5837C20.4485 17.3369 20.269 17.1711 20.0016 17.1711C19.7372 17.1711 19.5546 17.3369 19.5546 17.5837V26.0652C19.5546 26.312 19.7372 26.4778 20.0016 26.4778ZM22.3258 26.484C22.5757 26.484 22.7553 26.322 22.7621 26.0714L23.0058 17.5868C23.0126 17.3369 22.8369 17.1742 22.5725 17.1742C22.322 17.1742 22.1431 17.3369 22.1363 17.5806L21.8926 26.0683C21.8858 26.312 22.0584 26.484 22.3258 26.484Z",
    fill: "#1F2647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.175236e9c6a7113473956c32c8ef70f0.svg";
export { ForwardRef as ReactComponent };